import { neverHere } from "../tsHelpers";

export const asArray = () => [
  ContentType.BlogPost,
  ContentType.SampleItinerary,
  ContentType.Review,
  ContentType.LocationSection,
];

export const toSlug = (type: ContentType) => {
  switch (type) {
    case ContentType.BlogPost:
      return "blog";
    case ContentType.SampleItinerary:
      return "sample-itinerary";
    case ContentType.Review:
      return "review";
    case ContentType.LocationSection:
      return "location-section";
    default:
      neverHere(type);
  }
};

export const toClassName = (type: ContentType) => {
  return `content-type-${toSlug(type)}`;
};

export const toFriendlyName = (type: ContentType) => {
  switch (type) {
    case ContentType.BlogPost:
      return "Article";
    case ContentType.SampleItinerary:
      return "Trip idea"; // different, but consistent with existing branding
    case ContentType.Review:
      return "Review";
    case ContentType.LocationSection:
      return "Location section";
    default:
      neverHere(type);
  }
};

export const toKey = (content: IContent) => `content-${toSlug(content.type)}-${content.id}}`;
